import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-autocomplete-address',
  template: `<input class="form-control" type="text" [(ngModel)]="autocompleteInput" #addresstext [validAddress]="thisPlace" (ngModelChange)="clear()">`,
  styles: ``
})
export class AutocompleteAddressComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() addressType: string;
  @Input() initValue: string;
  @Input() theForm: NgForm;
  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  @ViewChild('addresstext') addresstext: any;

  // https://angular.dev/guide/directives/attribute-directives

  thisPlace: any;

  autocompleteInput: string;
  queryWait: boolean;

  constructor(private cd: ChangeDetectorRef) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.getPlaceAutocomplete();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['initValue']) {
      this.autocompleteInput = changes['initValue'].currentValue;
    }
  }

  clear(): void {
    this.thisPlace = null;
  }

  private getPlaceAutocomplete() {
    const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement,
      {
        componentRestrictions: { country: 'US' },
        types: [this.addressType]  // 'establishment' / 'address' / 'geocode'
      });


    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();
      this.thisPlace = place;
      this.invokeEvent(place);

      setTimeout(() => {
        this.theForm.form.updateValueAndValidity();
        this.cd.detectChanges();
      });
    });
    /*
        setTimeout(() => {
          const e = this.addresstext;
          document.querySelectorAll('.pac-container').forEach((x) => {
            x.setAttribute('data-tap-disabled', 'true');
            x.addEventListener('click', function (ev) {
              console.log('in blur');
              console.log(ev);
              e.nativeElement.blur();
            });
            x.addEventListener('touchend', function (ev) {
              console.log('in touchstart');
              console.log(ev);
              //(ev.target as any).click();
              ev.stopImmediatePropagation();
            });
          })
        }, 500);
    
        /*
            var container = document.getElementsByClassName('pac-container');
            // disable ionic data tab
            container.attr('data-tap-disabled', 'true');
            // leave input field if google-address-entry is selected
            angular.element(container).on("click", function(){
                document.getElementById('searchBar').blur();
            });
        /*
            this.addresstext.nativeElement.addListener('keypress', function(e: any){
              //Fix for fastclick issue
              document.getElementsByClassName('pac-container')
              var g_autocomplete = $("body > .pac-container").filter(":visible");
              g_autocomplete.bind('DOMNodeInserted DOMNodeRemoved', function(event) {
                  $(".pac-item", this).addClass("needsclick");
              });
              //End of fix
          });*/
  }

  invokeEvent(place: Object) {
    this.setAddress.emit(place);
  }
}
